import { render, staticRenderFns } from "./r-card-album-dialog.vue?vue&type=template&id=190c83b4&scoped=true"
import script from "./r-card-album-dialog.vue?vue&type=script&lang=js"
export * from "./r-card-album-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-card-album-dialog.vue?vue&type=style&index=0&id=190c83b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c83b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('190c83b4')) {
      api.createRecord('190c83b4', component.options)
    } else {
      api.reload('190c83b4', component.options)
    }
    module.hot.accept("./r-card-album-dialog.vue?vue&type=template&id=190c83b4&scoped=true", function () {
      api.rerender('190c83b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/card-album/r-card-album-dialog.vue"
export default component.exports